import { ReactElement, ReactNode, useId } from "react";
import './input-checkbox.css'
import { clsx } from "../../functions.ts";

export default function InputCheckbox (props: {
	label: string,
	value: boolean,
  infoButton?: ReactNode,
  onChange: (value: boolean) => void,
}){
  const id = useId();
  return <div className={"input input-checkbox"}>
        <label className={"input__label"}></label>
        <div className="input-checkbox__container">
          <div className={clsx("input-checkbox__box", props.value && "input-checkbox__box--active")}>
          <input className={"input-checkbox__input input"} id={id} type="checkbox" checked={props.value || false} onChange={(_)=>{
            props.onChange(!(props.value || false));
          }}/>
          </div>
          <label className={"input-checkbox__label"} htmlFor={id}><span dangerouslySetInnerHTML={{__html:props.label}}></span>{props.infoButton}</label>
        </div>
    </div>
}
